import axios from "axios";
import { ApiLink } from "../../../../APILink/ApiLink";
import authHeader from "../../../../Auth/authHeader";

const serverMessage = (error, fallback) => {
  const data = error?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data?.message) return data.message;
  if (data?.Message) return data.Message;
  if (error?.message) return error.message;
  return fallback;
};

export const getCompoundArticleErrorMessage = (error, fallback) => {
  const message = String(serverMessage(error, fallback) || "").trim();
  const normalized = message.toLowerCase();
  const status = Number(error?.response?.status || 0);

  if (!message) return fallback;

  if (
    normalized.includes("network error") ||
    normalized.includes("failed to fetch") ||
    normalized.includes("timeout")
  ) {
    return "Lidhja me serverin dështoi. Ju lutem provoni përsëri.";
  }

  if (normalized.includes("<!doctype") || normalized.includes("<html")) {
    return fallback;
  }

  if (
    normalized.includes("request failed with status code 400") ||
    normalized.includes("bad request")
  ) {
    return "Kërkesa nuk u pranua nga serveri. Kontrolloni të dhënat dhe provoni përsëri.";
  }

  if (
    normalized.includes("request failed with status code 401") ||
    normalized.includes("unauthorized")
  ) {
    return "Nuk keni autorizim për këtë veprim.";
  }

  if (
    normalized.includes("request failed with status code 403") ||
    normalized.includes("forbidden")
  ) {
    return "Qasja në këtë veprim është e ndaluar.";
  }

  if (
    normalized.includes("request failed with status code 404") ||
    status === 404
  ) {
    return "Artikulli i përbërë nuk u gjet.";
  }

  if (
    normalized.includes("request failed with status code 500") ||
    normalized.includes("internal server error") ||
    status >= 500
  ) {
    return fallback || "Ndodhi një gabim në server. Ju lutem provoni përsëri.";
  }

  if (
    normalized.includes("keynotfound") ||
    normalized.includes("nuk ekziston") ||
    normalized.includes("nuk u gjet")
  ) {
    return "Artikulli i përbërë nuk u gjet.";
  }

  if (
    normalized.includes("barcode") &&
    (normalized.includes("ekziston") || normalized.includes("duplicate") || normalized.includes("zënë"))
  ) {
    return "Ky barkod ekziston për një artikull tjetër.";
  }

  if (
    normalized.includes("article") &&
    normalized.includes("already exists")
  ) {
    return "Ky artikull ekziston paraprakisht në sistem.";
  }

  if (
    (normalized.includes("article") || normalized.includes("em") || normalized.includes("name")) &&
    (normalized.includes("ekziston") || normalized.includes("already exists") || normalized.includes("duplicate"))
  ) {
    return "Ky emër artikulli ekziston për një artikull tjetër.";
  }

  if (
    normalized.includes("foreign key") ||
    normalized.includes("constraint") ||
    normalized.includes("lidhjet")
  ) {
    return "Disa nga të dhënat lidhëse nuk janë të vlefshme. Kontrollo grupin, njësinë, llogarinë dhe TVSH-në.";
  }

  if (
    normalized.includes("object reference") ||
    normalized.includes("nullreference") ||
    normalized.includes("cannot be null")
  ) {
    return "Mungojnë disa të dhëna të detyrueshme. Ju lutem kontrolloni formën.";
  }

  if (
    normalized.includes("sql") ||
    normalized.includes("exception") ||
    normalized.includes("invalid cast") ||
    normalized.includes("input string")
  ) {
    return fallback || "Ndodhi një gabim gjatë përpunimit të të dhënave.";
  }

  if (
    normalized.includes("delete") &&
    (normalized.includes("transaks") || normalized.includes("historik") || normalized.includes("document"))
  ) {
    return "Ky artikull nuk mund të fshihet sepse është përdorur në transaksione ose dokumente tjera.";
  }

  if (normalized.includes("articleotherdetails") || normalized.includes("njësi shitjeje")) {
    return "Artikulli duhet të ketë të paktën një opsion shitjeje.";
  }

  return message;
};

export async function fetchCompoundArticleById(id) {
  try {
    const response = await axios.get(`${ApiLink.API_URL}CompoundArticle/getArticleEdit/${id}`, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    throw new Error(getCompoundArticleErrorMessage(error, "Gabim gjatë ngarkimit të artikullit."));
  }
}

export async function createCompoundArticle(payload) {
  try {
    const response = await axios.post(
      `${ApiLink.API_URL}CompoundArticle/insertCompoundArticle`,
      payload,
      { headers: authHeader() },
    );
    return response.data;
  } catch (error) {
    throw new Error(getCompoundArticleErrorMessage(error, "Gabim gjatë ruajtjes së artikullit."));
  }
}

export async function updateCompoundArticle(id, payload) {
  try {
    const response = await axios.put(`${ApiLink.API_URL}CompoundArticle/${id}`, payload, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    throw new Error(getCompoundArticleErrorMessage(error, "Gabim gjatë përditësimit të artikullit."));
  }
}
